import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";
import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Transparencia from './components/Transparencia/Transparencia';
import Rubros from './components/Rubros/Rubros';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import Error404 from "./components/Error404/Error404";
import Servicios from "./components/Servicios/Servicios";
import Beneficiarios from "./components/Beneficiarios/Beneficiarios";
import Convocatorias from "./components/Convocatorias/Convocatorias";
import RegistrosAgenda from "./components/RegistrosAgenda/RegistrosAgenda";
import NuevoRegistroAgenda from "./components/NuevoRegistroAgenda/NuevoRegistroAgenda";
import Areas from "./components/Areas/Areas"; 
import Interes from "./components/Interes/Interes";
import Ticket from "./components/Ticket/Ticket";
import Inventario from "./components/Inventario/Inventario";
import Nuevo from "./components/Inventario/Nuevo";
import Panel from "./components/Panel/Panel";
import Agroquimicosabejas from "./components/AgroquimicosAbejas/AgroquimicosAbejas";
import Areasdependencia from "./components/AreasDependencia/AreasDependencia";
import Centroinnovacion from "./components/CentroInnovacion/CentroInnovacion";
import ComiteEtica from "./components/ComiteEtica/ComiteEtica";
import Indicadores from "./components/Indicadores/Indicadores";
import ManualOrganizacion from "./components/ManualOrganizacion/ManualOrganizacion";
import ManualProcedimientos from "./components/ManualProcedimientos/ManualProcedimientos";
import ProtocoloCero from "./components/ProtocoloCero/ProtocoloCero";
import CodigoConducta from "./components/CodigoConducta/CodigoConducta";
import DetalleAreas from "./components/DetalleAreas/DetalleAreas";
import ConvocatoriasHistorico from "./components/ConvocatoriasHistorico/ConvocatoriasHistorico";
import Cidt from "./components/CIDT/Cidt";
import DetalleAcciones from "./components/DetalleAcciones/DetalleAcciones";
import Acciones from "./components/Acciones/Acciones"; 
import Organigrama from "./components/Organigrama/Organigrama";
import InstrumentosArchivisticos from"./components/InstrumentosArchivisticos/InstrumentosArchivisticos";
import GeneralArchivistica from"./components/GeneralArchivistica/GeneralArchivistica";
import Manualinterno from "./components/ManualInterno/Manualinterno";
import Cocodi from "./components/Cocodi/Cocodi";
import CampoDigital from "./components/CampoDigital/CampoDigital";
import Contacto from "./components/Contacto/Contacto";
import Informe from "./components/Informe/Informe";
import Buzondenuncias from "./components/Buzondenuncias/Buzondenuncias";
import Estructura from "./components/Estructura/Estructura";




function App() {
  return (
    <BrowserRouter>
<Header/>
<Routes>
<Route exact path="/" element={ <Inicio /> } />
<Route exact path="/Transparencia" element={ <Transparencia/> } />
<Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
<Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
<Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
<Route exact path="/Agenda" element={ <Agenda/> } />
<Route exact path="*" element={<Error404 /> } />
<Route exact path="/Servicios"element={ <Servicios/>} />
<Route exact path="/Beneficiarios"element={ <Beneficiarios/>} />
<Route exact path="/Convocatorias"element={ <Convocatorias/>} />
<Route exact path="/RegistrosAgenda"element={ <RegistrosAgenda/>} />
<Route exact path="/NuevoRegistroAgenda"element={ <NuevoRegistroAgenda/>} />
<Route exact path="/Areas"element={ <Areas/>} />
<Route exact path="/LigasInteres"element={ <Interes/>} />
<Route exact path="/Ticket"element={ <Ticket/>} />
<Route exact path="/Inventario"element={ <Inventario/>} />
<Route exact path="/Inventario/Nuevo"element={ <Nuevo/>} />
<Route exact path="/Panel"element={ <Panel/>} />
<Route exact path="/AgroquimicosAbejas"element={ <Agroquimicosabejas/>} />
<Route exact path="/AreasDependencia"element={ <Areasdependencia/>} />
<Route exact path="/CentroInnovacion"element={ <Centroinnovacion/>} />
<Route exact path="/ComiteEtica"element={ <ComiteEtica/>} />
<Route exact path="/Indicadores"element={ <Indicadores/>} />
<Route exact path="/ManualOrganizacion"element={ <ManualOrganizacion/>} />
<Route exact path="/ManualProcedimientos"element={ <ManualProcedimientos/>} />
<Route exact path="/ProtocoloCero"element={ <ProtocoloCero/>} />
<Route exact path="/CodigoConducta"element={ <CodigoConducta/>} />
<Route exact path="/ConvocatoriasHistorico"element={ <ConvocatoriasHistorico/>} />
<Route exact path="/Areas/:enlace" element={ <DetalleAreas/> } />
<Route exact path="/CIDT/" element={ <Cidt/> } />
<Route exact path="/Acciones/:enlace" element={ <DetalleAcciones/> } />
<Route exact path="/Acciones"element={ <Acciones/>} />
<Route exact path="/Organigrama"element={ <Organigrama/>} />
<Route exact path="/InstrumentosArchivisticos" element={<InstrumentosArchivisticos/>}/>
<Route exact path="/GeneralArchivistica" element={<GeneralArchivistica/>}/>
<Route exact path="/Manualinterno"element={ <Manualinterno/>} />
<Route exact path="/Cocodi"element={ <Cocodi/>} />
<Route exact path="/CampoDigital" element={ <CampoDigital /> } />
<Route exact path="/Contacto" element={ <Contacto /> } />
<Route exact path="/Informe" element={ <Informe /> } />
<Route exact path="/Buzondenuncias" element={ <Buzondenuncias /> } />
<Route exact path="/Estructura" element={ <Estructura /> } />



</Routes>


<Footer/>
    </BrowserRouter>
  );
}

export default App;
